/**
 * Messages queued while the model answers (ADMIN-212): helpers for the list above the composer.
 */

type QueuePart =
  | { readonly type: "text"; readonly text: string }
  | {
      readonly type: "file";
      readonly data: string;
      readonly mimeType: string;
      readonly filename?: string | undefined;
    };

/** A queued message's text, as typed. */
export function queueItemText(parts: readonly QueuePart[]): string {
  return parts
    .filter((p): p is Extract<QueuePart, { type: "text" }> => p.type === "text")
    .map((p) => p.text)
    .join("\n\n");
}

/** A queued message's attachments, as files the composer can take back. */
export function queueItemFiles(parts: readonly QueuePart[]): File[] {
  return parts
    .filter((p): p is Extract<QueuePart, { type: "file" }> => p.type === "file")
    .map((p) => {
      const url = /^data:/.test(p.data) ? p.data : `data:${p.mimeType};base64,${p.data}`;
      const [, base64 = ""] = url.split(",", 2);
      const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
      return new File([bytes], p.filename ?? "attachment", { type: p.mimeType });
    });
}

/**
 * The composer's text once a queued message is taken back to edit: the queued text first, then
 * whatever was being typed, so nothing is lost.
 */
export function mergeIntoDraft(queued: string, draft: string): string {
  if (!draft.trim()) return queued;
  if (!queued.trim()) return draft;
  return `${queued}\n\n${draft}`;
}
